import React from 'react';

export default function Spinner() {
    return(
        <div className='container '>
            <h1>Please be patient, it is coming from space</h1>
        </div>
    );
}